import { useCallback, useEffect, useRef } from 'react';

const useEventCallback = <T extends (...args: any[]) => any>(callback: T): T => {
  const callbackRef = useRef<T>(callback);

  // Update the ref to the latest callback on each render
  useEffect(() => {
    callbackRef.current = callback;
  });

  return useCallback((...args: any[]) => {
    return callbackRef.current(...args);
  }, []) as T;
};

export default useEventCallback;
